import { render, staticRenderFns } from "./AnimatedLikeButton.vue?vue&type=template&id=200a08d1&scoped=true"
import script from "./AnimatedLikeButton.vue?vue&type=script&lang=js"
export * from "./AnimatedLikeButton.vue?vue&type=script&lang=js"
import style0 from "./AnimatedLikeButton.vue?vue&type=style&index=0&id=200a08d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a08d1",
  null
  
)

export default component.exports